

<div class="ft-parent-layout mat-elevation-z1" [class.ft-content-margin]="true" fxFlex fxLayout="column">
  <h1>dashboard</h1>

</div>
